<template>
  <div v-if="isMounted" :key="route" class="loader bg-white pt-10 p-10" style="border-radius: 5px">
    <vs-row vs-w="12">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
        <span style="font-size: 18px; color: black; font-weight: bold">{{
          getProjectSelected.projectName
        }}</span>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="4" vs-xs="12">
        <div class="vx-row items-center justify-center" style="font-size: 30px; color: black; font-weight: bold">MTBE
          DASHBOARD 2024</div>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
        <span style="font-size: 14px; color: black; font-weight: bold; text-align: right">Last Updated:<br />
          {{ lastUpdate }}</span>
      </vs-col>
    </vs-row>


    <div
      class="p-6 vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
      <h2>{{ titleSelected }}</h2>
    </div>

    <div class="vx-row items-center justify-center">
      <div class="vx-col w-1/2 md:w-1/3 xl:w-1/6 items-center">
        <statistics-card-line hideChart class="mb-base" icon="Share2Icon" :statistic="totalJoints"
          statisticTitle="Total Joints" />
      </div>
    </div>
    <vs-row>

      <vs-col vs-lg="12" vs-sm="12" vs-xs="12" vs-type="flex" vs-justify="center" vs-align="center">
        <div class="vx-row items-center justify-center">
          <template v-for="(fName, fIndex) in settings.data">

            <component v-if="fName.type == 'radialChart'" :key="fIndex" :is="fName.type" :index="fIndex"
              :settings="fName"></component>
          </template>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
// import AdvanceTable from "./advance_table.vue";

import { mapGetters } from "vuex";

import { alertMixin } from "../../mixin/alertMixin";
import { axiosMixin } from "../../mixin/axiosMixin";
import { helperMixin } from "../../mixin/helperMixin";
import { dbSettingsMixin } from "./dbSettingsMixin";

import statistics from "../../components/aron/dashboard_items/statistics/statistics.vue";
import statisticsiconright from "../../components/aron/dashboard_items/statistics/statisticsIconRight.vue";
import horizontalBarChart from "../../components/aron/dashboard_items/chart/horizontalBarChart.vue";
import pieChart from "../../components/aron/dashboard_items/chart/pieChart.vue";
import barChart from "../../components/aron/dashboard_items/chart/barChart.vue";
import radialChart from "../../components/aron/dashboard_items/chart/radialChart.vue";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";

export default {
  components: {
    statistics,
    pieChart,
    barChart,
    statisticsiconright,
    horizontalBarChart,
    radialChart,
    StatisticsCardLine,
  },
  mixins: [dbSettingsMixin, alertMixin, axiosMixin, helperMixin],
  watch: {
    $route(to, from) {
      this.route = this.$route.params.subject;
      this.currentView = "list"; //reset the view
    },
  },
  methods: {},
  data() {
    return {
      reloadMarker: true,
      route: "detailDashboard",
      isMounted: false,
      currentView: "list",
      dataReady: false,
      settings: {},
      lastUpdate: "",
      totalJoints: 0,
      plantArea: {},
      openJointCount: [],
      boxUpJointCount: [],
      CompletedJointCount: [],
      titleSelected: "OVERALL",
      defaultSelected: "OVERALL",
    };
  },
  computed: {
    ...mapGetters({
      getUserInfo: "auth/getUserInfo",
      getProjectSelected: "auth/getProjectSelected",
    }),
  },
  methods: {
    startLoading(id) {
      console.log("loading ID:", id);
      this.$vs.loading({
        container: "." + id,
        scale: 0.6,
      });
    },
    stopLoading(id) {
      this.$vs.loading.close("." + id + " > .con-vs-loading");
    },
    filterJoints(thePackage) {
      this.titleSelected = thePackage == "all" ? this.defaultSelected : thePackage;
      this.aronPost("getByPackage", { plantArea: thePackage, projectId: this.getProjectSelected.id }, "", "")
        .then((response) => {
          if (response.status == 200) {
            this.dataReady = true;
            this.isMounted = true;
            console.log("responssse:", response);
            this.reloadMarker = this.reloadMarker ? false : true;

            this.totalJoints = response.data.values.totalJoints;

            this.updateItemInObject(
              this.settings.data,
              "dataName",
              "value",
              response.data.values
            );
            console.log("settings after:", this.settings.data);
            this.lastUpdate = response.data.values.dateTime;
          }

          // this.stopLoading("loader");
        })
        .catch((error) => {
          // this.decodeErrorFromAxios(error);
          //  this.stopLoading("loader");
        });
    },
    getData() {
      // this.startLoading("loader");
      this.addToObject(this.settings.filter, {
        projectId: this.getProjectSelected.id,
      });
      console.log("settings:", this.settings);

      //

      this.aronPost(this.settings.endPoint, this.settings.filter, "", "")
        .then((response) => {
          console.log("response:", response);
          if (response.data.status == "true") {
            console.log("responssse:", response);
            this.reloadMarker = this.reloadMarker ? false : true;

            this.totalJoints = response.data.values.totalJoints;


            this.plantArea = response.data.values.plantArea;

            this.updateItemInObject(
              this.settings.data,
              "dataName",
              "value",
              response.data.values
            );
            console.log("settings after:", this.settings.data);
            console.log("totalJoints:", this.totalJoints);
            this.lastUpdate = response.data.values.dateTime;
            this.dataReady = true;
            this.isMounted = true;

            this.filterJoints("all");
          } else {
            this.errorAlert("Error", response.data.error);
          }

          // this.stopLoading("loader");
        })
        .catch((error) => {
          console.log("error:", error);
          this.stopLoading("loader");
        });
    },
  },
  created() {
    this.dataReady = false;
  },
  mounted() {
    this.settings = this.getDashboard("detail");
    console.log("this.settings in main:", this.settings);

    this.getData();
  },
};
</script>